import { useFormikContext } from 'formik'
import React from 'react'
import FormCheckbox from '../form/FormCheckbox'
import FormDescription from '../form/FormDescription'
import FormDoubleTextInput from '../form/FormDoubleTextInput'
import FormDropdown from '../form/FormDropdown'
import FormFileUpload from '../form/FormFileUpload'
import FormRadioButtonGroup from '../form/FormRadioButtonGroup'
import FormSectionHeader from '../form/FormSectionHeader'
import FormTextArea from '../form/FormTextArea'
import FormTextInput from '../form/FormTextInput'

export const runConditionsCheck = (
  { conditions, conditionRule, showRule },
  values,
) => {
  const matchingConditions = conditions.filter(condition => {
    const fieldName = condition.field.replace('{', '').replace('}', '')
    if (condition.condition === '=') {
      return values[fieldName] === condition.value
    }

    if (condition.condition === '!=') {
      return values[fieldName] !== condition.value
    }

    return true
  })
  const conditionCheckPass =
    conditionRule === 'all'
      ? matchingConditions.length === conditions.length
      : matchingConditions.length > 0

  return showRule === 'show' ? conditionCheckPass : !conditionCheckPass
}

const DynamicFormField = ({ __typename, id, conditions, ...rest }) => {
  const { values } = useFormikContext()

  const mapping = {
    CraftContent_Field_Html: <FormDescription key={id} {...rest} />,
    CraftContent_Field_Dropdown: <FormDropdown key={id} {...rest} />,
    CraftContent_Field_Radio: <FormRadioButtonGroup key={id} {...rest} />,
    CraftContent_Field_Group: <FormDoubleTextInput key={id} {...rest} />,
    CraftContent_Field_SingleLineText: <FormTextInput key={id} {...rest} />,
    CraftContent_Field_Email: <FormTextInput key={id} isFullWidth {...rest} />,
    CraftContent_Field_MultiLineText: <FormTextArea key={id} {...rest} />,
    CraftContent_Field_Checkboxes: <FormCheckbox key={id} {...rest} />,
    CraftContent_Field_Heading: <FormSectionHeader key={id} {...rest} />,
    CraftContent_Field_FileUpload: <FormFileUpload key={id} {...rest} />,
  }

  const shouldShow = runConditionsCheck(JSON.parse(conditions), values)

  if (mapping[__typename] && shouldShow) {
    return mapping[__typename]
  }

  return null
}

export default DynamicFormField
